export default __webpack_public_path__ + "static/media/batteraside4.b8b780dc.png";